<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeCode"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeCode" :campaign="campaign" />

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Model } from "survey-core";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import MicrositeAxios from "@/config/microsite-service";
import {
  addClassQlEditorToSDDisplay,
  customThemeSurveyJS,
  formatHtmlDetailDefault,
} from "../../../config/general-function";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";

export default {
  name: "MicrositeCode",
  inject: ["isAppLoading"],
  components: {
    Survey,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    survey: null,
    campaign: null,
    surveyJson: null,
    header: null,
    themeName: null,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },

    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  async created() {
    await this.getCampaign();
    this.getSurveyAndTheme();
    this.themeName = this.campaign.template.name;

    this.survey = new Model(this.surveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;

    this.handleUploadImage();
    this.handleSubmit();
    this.checkMaxUpload();
    // ========== ========== ========== ==========
    addClassQlEditorToSDDisplay();
  },
  computed: {
    ...mapState("microsite", ["user"]),
    ...mapState("defaultSystem", ["site"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
    async getCampaign() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "microsite-error",
          params: { slug: this.$route.params.slug },
        });
      }
    },
    getSurveyAndTheme() {
      const surveyJson = JSON.parse(this.campaign.survey_json);
      if (surveyJson && surveyJson.code) {
        let codeJson = surveyJson.code;
        this.header = codeJson["elements"][0];
      }
      if (surveyJson && surveyJson.code) {
        this.surveyJson = surveyJson.code;
      } else {
        this.surveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).code;
      }
      if (Array.isArray(this.surveyJson?.elements)) {
        for (let item of this.surveyJson.elements) {
          if (item.type == "file" && item.storeDataAsText == undefined) {
            item.storeDataAsText = false;
          }
        }
      }

      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
    handleUploadImage() {
      this.survey.onUploadFiles.add(async (_, options) => {
        // ========== ========== ========== ==========
        const fileLimitMB = 40;
        if (Array.isArray(options.files) && options.files.length > 0) {
          let checkSize = false;
          for (let item of options.files) {
            if (item?.size / 1000000 > fileLimitMB) {
              checkSize = true;
              break;
            }
          }
          if (checkSize) {
            options.callback("error");
            const errText = this.$t("microsite.maxFileSizeAllowed", {
              size: fileLimitMB,
            });
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2500,
            });
            Toast.fire({
              icon: "error",
              title: errText,
            });
            return;
          }
        }
        // ========== ========== ========== ==========
        const getParam = () => {
          return {
            site_id: this.site.id,
            campaign_id: this.campaign.id,
          };
        };
        options.files.forEach(function (file) {
          const formData = new FormData();
          formData.append("image", file);
          const { site_id, campaign_id } = getParam();

          MicrositeAxios.post(
            `uploadImageTransaction/${site_id}?campaign=${campaign_id}`,
            formData
          )
            .then(({ data }) => {
              if (data.status == "success") {
                options.callback("success", [
                  {
                    file: file,
                    content: data.data?.url,
                  },
                ]);
              }
            })
            .catch((err) => {
              throw err;
            });
        });
      });
    },
    handleSubmit() {
      this.survey.onComplete.add(async () => {
        await this.onSubmit();
      });
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        if (["image_confirm"].includes(options.question.name)) {
          const element = options.htmlElement;
          element.style.cursor = "pointer"; // Optional: Change cursor to indicate clickable
          element.onclick = () => {
            if (options.question.name == "image_confirm") {
              const isSurveyHasErrors = this.survey.hasErrors();
              if (isSurveyHasErrors) return;
              this.onSubmit();
            }
          };
        }
      });
    },
    async onSubmit() {
      this.isAppLoading(true);
      try {
        await MicrositeAxios.post(`submitCode/${this.campaign.id}`, {
          code: this.survey.data,
          phone: this.user.phone,
        }).then((res) => {
          this.$store.commit("microsite/SET_HISTORY_CODE", {
            history_code: res.data.data,
          });

          setTimeout(() => {
            this.$router.push({ name: "microsite-thankyou" });
          }, 3000);
        });
      } catch (error) {
        this.$swal
          .fire({
            icon: "error",
            text: error.response.data.message,
            showConfirmButton: true,
          })
          .then(() => {
            this.$router.go(0);
          });
        console.log(error);
      }
      this.isAppLoading(false);
    },
    checkMaxUpload() {
      this.survey.onValidateQuestion.add((sender, options) => {
        const value = options.value;
        const question = options.question;
        const type = question?.getType();
        if (type == "file") {
          const maxUpload = question?.maxUpload || question?.jsonObj?.maxUpload;
          if (value?.length > maxUpload) {
            options.error = this.$t("microsite.maxFilesAllowed", {
              count: maxUpload,
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
::v-deep .footer p {
  word-break: break-all;
  margin-bottom: 0px !important;
}
::v-deep .v-footer {
  margin-top: auto !important;
  margin-bottom: 0px !important;
}

/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
